import React from "react";
import { Modal, Spinner, Col, Row } from "react-bootstrap";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { useTranslation } from "_metronic/i18n/language";
import { CircularProgressWithLabel } from "../Progress";
import { useThemeApp } from "_metronic/materialUIThemeProvider/ThemeProvider";

const useStyles = makeStyles(theme => ({
  modalBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  message: {
    fontSize: "1.1em",
  },
  spinnerBorder: {
    width: "3rem",
    height: "3rem",
  },
}));

export default function Loading(props) {
  const translate = useTranslation();
  let isDarkMode = false;

  try {
    const themeApp = useThemeApp();
    isDarkMode = themeApp?.isDarkMode ?? false;
  } catch (error) {
    console.warn("useThemeApp foi usado fora do ThemeProvider");
  }

  function handleClose() {
    return false;
  }

  const classes = useStyles();
  // const locale = useSelector(({ i18n }) => i18n.lang);

  return (
    <>
      {props.isLoading ? (
        <Modal
          show={true}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="loading-modal"
          style={{ zIndex: 2000 }}
          onHide={() => handleClose()}
        >
          <Modal.Body
            className={classes.modalBody}
            style={{
              backgroundColor: isDarkMode ? "#000" : "#FFF",
            }}
          >
            <Row className="show-grid">
              <Col xs={12} md={12}>
                <h2 style={{ color: isDarkMode ? "#FFF" : "#000" }}>
                  {props.msg ? props.msg : translate("screens.loading.title")}
                </h2>
              </Col>
            </Row>
            <Row className="show-grid">
              <Col xs={12} md={12}>
                <p
                  className={classes.message}
                  style={{ color: isDarkMode ? "#FFF" : "#000" }}
                >
                  {translate("screens.loading.message")}
                </p>
              </Col>
            </Row>
            <Row className="show-grid">
              {!!props.progress ? (
                <CircularProgressWithLabel
                  value={props.progress}
                  sx={{
                    color: isDarkMode ? "#90caf9" : "#1A73E8",
                  }}
                />
              ) : (
                <Spinner
                  animation="border"
                  variant={isDarkMode ? "light" : "dark"}
                  className={classes.spinnerBorder}
                  size="xs"
                  style={{
                    color: isDarkMode ? "#90caf9" : "#1A73E8",
                  }}
                />
              )}
            </Row>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
}
